module.exports = __webpack_public_path__ + "img/circle-fill.4c4b6292.svg";